import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "Other Email",
    "External Email",
    "email",
    "Direct Mail",
    "Email Newsletter",
    "Email Retargeting",
    "Native Email",
    "Newsletter",
    "PROMO EMAIL",
    "SFMC Emails",
  ],
  iconColor: "#681E06", // saturn
  getIcon(options) {
    return createIcon(
      `<path
        d="M7.125 9.03906L12 12.3906L16.875 9.03906V8.125H7.125V9.03906ZM16.875 10.3984L12 13.75L7.125 10.3984V14.875H16.875V10.3984ZM6 14.875V9.625V8.125V7H7.125H16.875H18V8.125V9.625V14.875V16H16.875H7.125H6V14.875Z"
        fill="#681E06"
      />`,
      "#F0E8E6", // saturn-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
